module.exports = __webpack_public_path__ + "static/media/rss.dbaa0714.svg";